<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <header>
    <div class="headline">
      <h1>
        {{ 'Split_Lot_Items_Detail_Title' | translateWF: 'Split Lot Items' }}
      </h1>
    </div>
    <div class="buttons">
      <p-button *ngIf="canEdit()" [label]="'Common_Save' | translateWF: 'Save'" (click)="save()" [disabled]="!canSave()" />
      <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <!-- Navigation Breadcrumbs -->
  <div class="content">
    <div class="cs-page-list-grid">
      <!-- General -->
      <p-panel header="General">
        <p-card>
          <label class="mb-2" for="lotItemSearch">{{ 'Split_Lot_Items_Detail_Lot_Item' | translateWF: 'Lot Item' }}</label>
          <p-autocomplete
            [inputId]="'lotItemSearch'"
            fluid
            #lotItemSearchRef="cslServerSearch"
            [cslServerSearch]="fetchLotItems"
            [suggestions]="lotItemSearchRef.results()"
            field="number"
            [formControl]="lotItemSearch"
            class="w-full"
            styleClass="w-full"
            (onSelect)="onLotItemSelected($event)"
            [showClear]="true"
            (onClear)="onLotItemSelected()"
            [delay]="2000"
          ></p-autocomplete>
        </p-card>
      </p-panel>

      <!-- Summary -->
      <p-panel header="Summary">
        <p-card>
          <div class="form-box-row justify-between mb-4" *ngIf="selectedItemMaster()">
            <span class="font-medium">{{ 'Split_Lot_Items_Detail_Item' | translateWF: 'Item' }}</span>
            <span class="text-gray-600">{{ itemDisplayInfo() }}</span>
          </div>
          <div class="form-box-row justify-between mb-2">
            <span class="font-medium">{{
              'Split_Lot_Items_Detail_Manufacturer_Label_ID'
                | translateWF
                  : 'Manufacturer
              Label ID'
            }}</span>
            <span class="text-gray-600">
              {{
                summaryInfo().manufacturerLabelId ||
                  ('Split_Lot_Items_Detail_Select_Lot_Item'
                    | translateWF
                      : 'Select
              Lot Item')
              }}
            </span>
          </div>
          <div class="form-box-row justify-between mb-4">
            <span class="font-medium">{{ 'Split_Lot_Items_Detail_Provider' | translateWF: 'Provider' }}</span>
            <span class="text-gray-600">
              {{ summaryInfo().provider || ('Split_Lot_Items_Detail_Select_Lot_Item' | translateWF: 'Select Lot Item') }}
            </span>
          </div>
          <div class="form-box-row justify-between mb-4">
            <span class="font-medium">{{ 'Split_Lot_Items_Detail_Manufacturer' | translateWF: 'Manufacturer' }}</span>
            <span class="text-gray-600">
              {{
                summaryInfo().manufacturer ||
                  ('Split_Lot_Items_Detail_Select_Lot_Item'
                    | translateWF
                      : 'Select Lot
              Item')
              }}
            </span>
          </div>
          <div class="form-box-row justify-between mb-4">
            <span class="font-medium">{{
              'Split_Lot_Items_Detail_Manufacturer_Lot_Number'
                | translateWF
                  : 'Manufacturer
              Lot Number'
            }}</span>
            <span class="text-gray-600">
              {{
                summaryInfo().manufacturerLotNumber ||
                  ('Split_Lot_Items_Detail_Select_Lot_Item'
                    | translateWF
                      : 'Select
              Lot Item')
              }}
            </span>
          </div>
          <div class="form-box-row justify-between mb-4">
            <span class="font-medium">{{
              'Split_Lot_Items_Detail_Original_Gross_Quantity'
                | translateWF
                  : 'Original Gross
              Quantity'
            }}</span>
            <span class="text-gray-600">
              {{
                summaryInfo().originalGrossQuantity
                  ? (summaryInfo().originalGrossQuantity | number: '1.2-2') + ' ' + uomLabel()
                  : ('Split_Lot_Items_Detail_Select_Lot_Item' | translateWF: 'Select Lot Item')
              }}
            </span>
          </div>
          <div class="form-box-row justify-between mb-4">
            <span class="font-medium">{{
              'Split_Lot_Items_Detail_Original_Net_Quantity'
                | translateWF
                  : 'Original Net
              Quantity'
            }}</span>
            <span class="text-gray-600">
              {{
                summaryInfo().originalNetQuantity
                  ? (summaryInfo().originalNetQuantity | number: '1.2-2') + ' ' + uomLabel()
                  : ('Split_Lot_Items_Detail_Select_Lot_Item' | translateWF: 'Select Lot Item')
              }}
            </span>
          </div>
          <div class="form-box-row justify-between">
            <span class="font-medium">{{
              'Split_Lot_Items_Detail_Current_Gross_Quantity'
                | translateWF
                  : 'Current Gross
              Quantity'
            }}</span>
            <span class="text-gray-600">
              {{
                summaryInfo().currentGrossQuantity
                  ? (summaryInfo().currentGrossQuantity | number: '1.2-2') + ' ' + uomLabel()
                  : ('Split_Lot_Items_Detail_Select_Lot_Item' | translateWF: 'Select Lot Item')
              }}
            </span>
          </div>
          <div class="form-box-row justify-between">
            <span class="font-medium">{{
              'Split_Lot_Items_Detail_Current_Net_Quantity'
                | translateWF
                  : 'Current Net
              Quantity'
            }}</span>
            <span class="text-gray-600">
              {{
                summaryInfo().currentNetQuantity
                  ? (summaryInfo().currentNetQuantity | number: '1.2-2') + ' ' + uomLabel()
                  : ('Split_Lot_Items_Detail_Select_Lot_Item' | translateWF: 'Select Lot Item')
              }}
            </span>
          </div>
        </p-card>
      </p-panel>
    </div>

    <!-- Split Lot Item Table -->
    <section *ngIf="canEdit()">
      <div class="under__line mb-[2rem] row-between-center">
        <h2>{{ 'Split_Lot_Items_Detail_Title' | translateWF: 'Split Lot Items Detail' }}</h2>
        <p-button
          [label]="'Split_Lot_Items_Detail_Split_Lot' | translateWF: 'Split Lot'"
          icon="pi pi-plus"
          variant="outlined"
          (click)="addSplitLotItem()"
          [disabled]="!selectedLotItem()"
        />
      </div>

      <!-- Table -->
      <div class="span-12-9-9">
        <p-table [value]="splitItemsForms()" styleClass="cs-datatable-overflow-visible">
          <ng-template #header>
            <tr>
              <th>{{ 'Split_Lot_Items_Detail_Net_Quantity' | translateWF: 'Net Quantity' }}</th>
              <th>{{ 'Split_Lot_Items_Detail_Packaging_Type' | translateWF: 'Packaging Type' }}</th>
              <th>{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
            </tr>
          </ng-template>

          <ng-template #body let-control let-i="rowIndex">
            <tr [formGroup]="control">
              <!-- Net Quantity -->
              <td>
                <p-inputgroup>
                  <input pInputText type="number" formControlName="originalNetQuantity" placeholder="0.0" min="0" step="0.1" />
                  <p-inputgroup-addon>{{ uomLabel() }}</p-inputgroup-addon>
                </p-inputgroup>
                <small class="text-red-500" *ngIf="control.get('originalNetQuantity')?.hasError('netGreaterThanGross') && control.get('originalNetQuantity')?.touched">
                  Net quantity cannot be greater than gross quantity
                </small>
              </td>

              <!-- Packaging Type -->
              <td>
                <p-select class="w-full" [options]="packagingTypeOptions" formControlName="packagingType" placeholder="Select Type" [showClear]="true" />
              </td>
              <td>
                <p-button icon="pi pi-minus" variant="text" size="small" (click)="removeSplitLotItem(i)" />
              </td>
            </tr>
          </ng-template>

          <!-- Summary Row -->
          @if (hasDataInTable()) {
            <ng-template #footer>
              <tr class="bg-gray-50 font-bold border-t-2">
                <td>{{ 'Items_Inventory_Group_Total_Quantity' | translateWF: 'Total Quantity' }}</td>

                <!-- Total Net Quantity -->
                <td>
                  <p-inputgroup>
                    <input pInputText type="number" [value]="totalNetQuantity()" disabled />
                    <p-inputgroup-addon>{{ uomLabel() }}</p-inputgroup-addon>
                  </p-inputgroup>
                </td>
                <td colspan="3"></td>
              </tr>
            </ng-template>
          }
        </p-table>

        @if (!hasDataInTable()) {
          <div class="text-center py-8 text-gray-500">
            {{
              selectedLotItem()
                ? ('Split_Lot_Items_Detail_No_Split_Items'
                  | translateWF
                    : 'No split items created yet. Click "Split Lot" to
          add items.')
                : ('Split_Lot_Items_Detail_No_Lot_Selected'
                  | translateWF
                    : 'Please select a lot item first to start
          splitting.')
            }}
          </div>
        }
      </div>
    </section>

    <!-- Existing Split Lot Item Table -->
    <p-panel [header]="'Split_Lot_Items_Detail_Title_Existing' | translateWF: 'Existing Split Lot Items Detail'">
      <!-- Table -->
      <p-card data-variant="compact">
        <p-table [value]="existingSplitLotItem()" styleClass="cs-datatable-overflow-visible">
          <ng-template #header>
            <tr>
              <th>{{ 'Split_Lot_Items_Detail_Split_Lot' | translateWF: 'Split Lot' }}</th>
              <th>{{ 'Split_Lot_Items_Detail_Gross_Quantity' | translateWF: 'Gross Quantity' }}</th>
              <th>{{ 'Split_Lot_Items_Detail_Net_Quantity' | translateWF: 'Net Quantity' }}</th>
              <th>{{ 'Split_Lot_Items_Detail_Packaging_Type' | translateWF: 'Packaging Type' }}</th>
              <th>{{ 'Common_Print' | translateWF: 'Print' }}</th>
            </tr>
          </ng-template>

          <ng-template #body let-itemExisting let-i="rowIndex">
            <tr>
              <!-- ID -->
              <td>
                {{ itemExisting.number }}
              </td>

              <!-- Gross Quantity -->
              <td>
                {{ (itemExisting.grossQuantity | number: '1.2-2') + ' ' + uomLabel() }}
              </td>

              <!-- Net Quantity -->
              <td>
                {{ (itemExisting.netQuantity | number: '1.2-2') + ' ' + uomLabel() }}
              </td>

              <!-- Packaging Type -->
              <td>
                {{ getPackagingTypeLabel(itemExisting.packagingType) }}
              </td>
              <td>
                <p-button label="Print Label" (onClick)="printLotItem(itemExisting.id)" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </p-panel>
  </div>
</main>
